import { SET_PICS, SET_PICS_LOADING } from './types'

export const setfPic = (pics) => {
    console.log('..masuk picAction')
    return {
        type : SET_PICS,
        payload : pics
    }
}

export const setLoading = (value) => {
    return {
        type : SET_PICS_LOADING,
        payload : value
    }
}